<template>
  <div>
    <media
      :entity-id="workerId"
      entity-key="worker_id"
      :api-config="apiConfig"
      :can-edit-media="canEditWorkers()"
      :is-disabled="isDisabled"
    />
  </div>
</template>

<script>
import workers from "../../network/workers";
import permissions, {PERM} from "../../utilites/permissions";
import Media from "../../utilites/commonUi/Media.vue";

export default {
  name: 'WorkerMedia',
  components: { Media },
  mixins: [
    workers,
    permissions
  ],
  props: {
    isDisabled: Boolean,
    workerId: { type: Number, default: null }
  },
  computed: {
    apiConfig() {
      return {
        getMedia: this.getWorkerMedia,
        postMedia: this.postWorkerMedia,
        putMedia: this.putWorkerMedia,
        deleteMedia: this.deleteWorkerMedia,
        getFiles: this.getWorkerMediaFiles,
        getFileDownload: this.getWorkerMediaFileDownload,
        postFile: this.postWorkerMediaFiles,
        deleteFile: this.deleteWorkerMediaFiles
      };
    }
  },
  methods: {
    // Permissions
    canEditWorkers() {
      return this.hasPermission([PERM.WORKER_EDIT]);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkerMedia.vue